<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits([
  'update:currentPage',
  'update:sort',
  'search',
  'applyFilter',
  'clearFilters',
  'click',
  'close',
]);

const route = useRoute();

const contactListHeaderWrapper = ref(null);

const isNotSegmentView = computed(() => {
  return route.name !== 'contacts_dashboard_segments_index';
});

const isLabelView = computed(
  () => route.name === 'contacts_dashboard_labels_index'
);

const updateCurrentPage = page => {
  emit('update:currentPage', page);
};

const openFilter = () => {
  contactListHeaderWrapper.value?.onToggleFilters();
};

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex w-full h-full gap-4 overflow-hidden justify-evenly">
    <div class="flex flex-col w-full h-full transition-all duration-300">
      <header class="sticky top-0 z-10">
        <div class="flex flex-col items-start w-full gap-2 pt-4">
          <div class="settings-header">
            <h1>
              {{ headerTitle }}
            </h1>
            <div
              v-on-clickaway="() => emit('close')"
              class="relative group/knowledgebase-button"
            >
              <Button
                :label="buttonLabel"
                icon="i-lucide-circle-plus"
                size="md"
                class="group-hover/campaign-button:brightness-110 font-semibold"
                @click="handleButtonClick"
              />
              <slot name="action" />
            </div>
          </div>
        </div>
      </header>
      <main class="flex-1 overflow-y-auto pr-4">
        <div class="w-full py-4">
          <slot name="default" />
        </div>
      </main>
    </div>
  </section>
</template>
